import React, { Component } from 'react';

export class OfferDate extends Component {
    static displayName = OfferDate.name;

    constructor(props) {
        super(props);        
    }

    render() {
        //console.log(this.props);
        return (
        <React.Fragment>
            <span className="date">{new Date(this.props.start_time).toLocaleDateString(undefined, {weekday: 'short', day: '2-digit', month: 'short'})}</span> <br/>
            { (!this.props.onWay && !this.props.dateOnly) &&
            <span>{new Date(this.props.start_time).toLocaleTimeString(undefined, {hour: 'numeric', minute:'2-digit'})} to&nbsp;
                {new Date(this.props.end_time).toLocaleTimeString(undefined, {hour: 'numeric', minute:'2-digit'})}</span>
            }
            { (this.props.onWay) === true &&
            <span>We're on our way</span>
            }
        </React.Fragment>);
    }
}